<template>
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.title" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column  label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column  prop="title" label="音频名称" show-overflow-tooltip>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column  fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">详情</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog :title="operation == 'add' ? '新增音频': operation == 'edit' ? '编辑音频':'查看音频'" :close-on-click-modal="false"  @close="onCancel" :visible.sync="dialogVisible" :width="'600px'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-form-item class="mb-30" prop="title">
            <el-input v-model="addForm.title" :disabled="operation == 'view'" placeholder="请输入音频名称" />
          </el-form-item>

          <el-form-item class="mb-30">
            <el-input v-model="audioUrl" disabled placeholder="上传音频自动获取URL" />
          </el-form-item>

          <el-form-item class="avatar-uploader-form" prop="ext1">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept="audio/*" :data="configData" :show-file-list="false" :on-change="uploadVideoProcess" :on-success="handleAudioSuccess" :before-upload="beforeAudioUpload">
              <audio v-if="audioUrl != '' && !audioFlag" v-bind:src="audioUrl" class="w-100" controls="controls">
                您的浏览器不支持视频播放
              </audio>

              <div class="tip" v-else-if="audioUrl == '' && !audioFlag">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传音频</div>
              </div>
              <el-progress v-if="audioFlag == true" type="circle" v-bind:percentage="audioUploadPercent" style="margin-top: 7px"></el-progress>

            </el-upload>

            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept="image/*" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" style="width: 100%;height:150px;object-fit:contain;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传音频封面</div>
              </div>
              <div class="tip-img">建议图片大小：345 * 228</div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation !== 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  data() {
    const validateExt1 = (rule, value, callback) => {
      if (!this.addForm.ext1) {
        callback(new Error('音频地址不能为空'))
      } else {
        callback()
      }
    }
    return {
      form: {
        title: '',
      },
      radioId: '',
      operation: 'add',
      addForm: {
        title: "",
        ext1: ""
      },
      rules: {
        title: [{ required: true, message: '音频名称不能为空', trigger: 'blur' }],
        ext1: [{ required: true, validator: validateExt1, trigger: 'blur' }],
      },
      configData: {
        tableName: 'collect'
      },
      audioFlag: false,
      audioUrl: "",
      audioUploadPercent: 0,
      imgUrl: "",
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet.getElecticWaveList({
        ...this.form,
        type: this.radioId,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },


    // 重置查询
    resetForm() {
      this.form = {
        title: '',
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleView(obj) {
      this.operation = "view"
      this.$api.applet.getElecticWaveDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
            if (res.result.ext2) {
              if (res.result.ext2.indexOf('http') == -1) {
                this.imgUrl = `/singleMuseum/attach/getFile?fileId=${res.result.ext2}`
              }
            }
            if (res.result.ext1) {
              if (res.result.ext1.indexOf('http') == -1) {
                this.audioUrl = `/singleMuseum/attach/getFile?fileId=${res.result.ext1}`
              }
            }

          }
        }
      })
    },

    // 新增
    handleAdd() {
      this.operation = "add"
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      if (obj.ext2) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.ext2}`
      }

      if (obj.ext1) {
        this.audioUrl = `/singleMuseum/attach/getFile?fileId=${obj.ext1}`
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.delElecticWave({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeAudioUpload(file) {
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))

      if (fileType === '.wav' || fileType === '.mp3' || fileType === '.ogg' || fileType === '.acc' || fileType === '.webm') {
        return true
      } else {
        this.$message.error(
          '请上传正确的音频类型'
        )
        return false
      }
    },

    handleAudioSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        // this.audioFlag = false;
        // this.audioUploadPercent = 0;
        this.audioUrl = res.result.attPath
        this.addForm.ext1 = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    //进度条
    uploadVideoProcess(file, fileList) {    //注意在data中添加对应的变量名
      const self = this
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.'))

      if (fileType === '.wav' || fileType === '.mp3' || fileType === '.ogg' || fileType === '.acc' || fileType === '.webm') {
        if (file.status === 'ready') {
          this.audioFlag = true; // 显示进度条
          this.audioUploadPercent = 0;
          const interval = setInterval(() => {
            if (self.audioUploadPercent >= 99) {
              clearInterval(interval)
              return
            }
            self.audioUploadPercent += 1

          }, 20);
        }
        if (file.status === 'success') {
          setTimeout(() => {
            this.audioFlag = false; // 显示进度条
            this.audioUploadPercent = 100;
          }, 500)
        }
      } else {
        this.$message.error(
          '请上传正确的音频类型'
        )
        return false
      }
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return false
      }

      if (this.imageTypes.includes(fileType)) {
        return true
      } else {
        this.$message.error('请上传正确的图片类型')
        return false
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.ext2 = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    onSubmit() {
      const self = this
      this.$refs["form"].validate((valid, obj) => {
        if (valid) {
          let url = "addElecticWave"
          if (this.addForm.id) {
            url = "updateElecticWave"
          } else {
            this.addForm.ext3 = this.radioId
          }
          this.$api.applet[url](this.addForm).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '音频修改成功' : '新增音频成功',
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getData()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ""
      this.audioUrl = ""
      this.audioFlag = false
      this.$refs["form"].clearValidate()
    },
    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    },
  },
  created() {
    this.radioId = this.$route.query.id
    this.getData()

    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
      .el-date-editor,
      .el-select {
        width: 100%;
      }
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      .el-form-item__content {
        display: flex;
        .avatar-uploader {
         flex: 1;
          border: 1px dashed #8c939d;
          height: 150px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          &:first-child {
            margin-right: 20px;
          }
          .el-upload {
            width: 100%;
            height: 150px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .el-icon-plus {
            font-size: 20px;
          }

          .el-upload__text {
            line-height: 1;
          }
        }
      }
    }
  }
}
</style>